import type { FormattedCourse } from 'bundles/enroll-common/types/enrollSectionTypes';
import type { SpecializationReviewsPageCourseFragment } from 'bundles/reviews/queries/__generated__/SpecializationReviewsPage';

/**
 * Formats the specialization's course list (id/name/slug, from the reviews page data's
 * productCard.canonical.courses) into the shape `ConsumerEnrollButtonNotConfigurable` needs for
 * its `s12nCourses` prop. A local formatter rather than reusing
 * `getFormattedCourseDataFromConsumerSpecializationPageFieldsFragment`, since that one is typed
 * against the full `ConsumerSpecializationPageFieldsFragment` this page intentionally no longer
 * fetches.
 */
export const getFormattedCoursesForEnrollButton = (
  courses: SpecializationReviewsPageCourseFragment[]
): FormattedCourse[] =>
  courses.map((course) => ({
    id: course.id,
    slug: course.slug,
    name: course.name,
    link: `/learn/${course.slug}`,
    homeLink: `/learn/${course.slug}/home/welcome`,
  }));
